module.exports = __webpack_public_path__ + "img/img122.947b7eab.svg";